// extracted by mini-css-extract-plugin
export default {"page-user":"users_page-user__YfmqA","title":"users_title__9lTZM"};